export enum PopularCatalogEnum {
  POPULAR_BOOKS = 'Popular Books',
  ADO_YOUNG_ADULTS = 'Popular Ado Young Adults',
  BIEN_ETRE_PRATIQUE = 'Popular Bien Etre Pratique',
  ROMANS_FRANCOPHONES = 'Popular Romans Francophones',
  POLICIERS_THRILLERS = 'Popular Policiers Thrillers',
  COMICS = 'Popular Comics',
  ROMANS_ETRANGERS = 'Popular Romans Etrangers',
  MANGAS = 'Popular Mangas',
  ROMANS = 'Popular Romans',
  JEUNESSE = 'Popular Jeunnesse',
  ROMANS_SENTIMENTAUX = 'Popular Romans Sentimentaux',
  ROMANS_GENRE = 'Popular Romans Nouvelles De Genre',
  SHS = 'Popular Shs',
  BD = 'Popular Bd',
}

export enum ClilCatalogEnum {
  CLIL_POPULAR_BOOKS = 'Tous les genres',
  CLIL_ADO_YOUNG_ADULTS = 'Romans ados et jeunes adultes',
  CLIL_BIEN_ETRE_PRATIQUE = 'Livres de bien-être et vie pratique',
  CLIL_ROMANS_FRANCOPHONES = 'Romans francophones',
  CLIL_POLICIERS_THRILLERS = 'Romans policiers et thrillers',
  CLIL_COMICS = 'BD, comics et mangas',
  CLIL_ROMANS_ETRANGERS = 'Romans étrangers',
  CLIL_MANGAS = 'Mangas',
  CLIL_ROMANS = 'Romans',
  CLIL_JEUNESSE = 'Livres Jeunesse',
  CLIL_ROMANS_SENTIMENTAUX = 'Romans sentimentaux',
  CLIL_ROMANS_GENRE = 'Romans et nouvelles de genre',
  CLIL_SHS = 'Livres de SHS, histoire et religion',
  CLIL_BD = 'Bandes dessinées',
}
